import React, { FC } from 'react';
import './TodoOutputsByRecords.scss';
import {
	Table,
	TableHeader,
	TableRow,
	TableHeaderCell,
	TableBody,
	TableCell,
	TableCellLayout,
} from '@fluentui/react-components';
import { format } from 'date-fns';
import { DocumentRegular } from "@fluentui/react-icons";
import { RecordsDataSelectable } from '../../types/RecordsDataSelectable';

const { parseISO } = require("date-fns");

interface TodoOutputsByRecordsProps {
	outputsRecords: RecordsDataSelectable[];
}

function createDateWithFormat(dateString: string) {
	const date = parseISO(dateString);
	return format(date, "dd-MM-yyyy, HH:mm");
}

const TodoOutputsByRecords: FC<TodoOutputsByRecordsProps> = ({
	outputsRecords
}) => {
	return (
		<div className="TodoOutputsByRecords">
			<div className="table-header">
				<div className="table-info">
					<h4>Output Records</h4>
					<span className="record-count">{outputsRecords.length} records</span>
				</div>
			</div>

			{outputsRecords.length === 0 ? (
				<div className="empty-state">
					<DocumentRegular className="empty-icon" />
					<p>No output records available</p>
				</div>
			) : (
				<Table aria-label="Output Records Table" className="outputs-table">
					<TableHeader>
						<TableRow className="table-header-row">
							<TableHeaderCell className="header-cell">Record ID</TableHeaderCell>
							<TableHeaderCell className="header-cell">Process</TableHeaderCell>
							<TableHeaderCell></TableHeaderCell>
							<TableHeaderCell className="header-cell">Subprocess</TableHeaderCell>
							<TableHeaderCell></TableHeaderCell>
							<TableHeaderCell className="header-cell">Created On</TableHeaderCell>
							<TableHeaderCell className="header-cell">Status</TableHeaderCell>
							<TableHeaderCell className="header-cell">Output Data</TableHeaderCell>


						</TableRow>
					</TableHeader>
					<TableBody>
						{outputsRecords.map((record) => (
							<TableRow key={record.id} className="table-body-row">
								<TableCell className="body-cell">
									<span className="record-id">{record.id}</span>
								</TableCell>
								<TableCell className="body-cell" colSpan={2}>
									<TableCellLayout truncate>
										<span className="process-name">{record.process}</span>
									</TableCellLayout>
								</TableCell>
								<TableCell className="body-cell" colSpan={2}>
									<TableCellLayout truncate>
										<span className="subprocess-name">{record.subprocess}</span>
									</TableCellLayout>
								</TableCell>
								<TableCell className="body-cell">
									<span className="date-created">{createDateWithFormat(record.created_on)}</span>
								</TableCell>
								<TableCell className="body-cell">
									<span className={`status-badge status-${record.status.toLowerCase().replace(/\s+/g, '-')}`}>
										{record.status}
									</span>
								</TableCell>
								<TableCell className="body-cell">
									<TableCellLayout className="output-data-cell">
										{record.data ? (
											<div className="output-data-preview">
												{typeof record.data === 'object' ?
													`${Object.keys(record.data).length} fields` :
													String(record.data).slice(0, 50) + (String(record.data).length > 50 ? '...' : '')
												}
											</div>
										) : (
											<span className="no-data">No data</span>
										)}
									</TableCellLayout>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			)}
		</div>
	);
};

export default TodoOutputsByRecords;
